"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/**
 * Local Imports
 */

const Switch = /*#__PURE__*/(0, _react2.styled)("input")({
  name: "Switch",
  class: "pl-syhbxxj"
});
const Label = /*#__PURE__*/(0, _react2.styled)("label")({
  name: "Label",
  class: "pl-ld93fki"
});

/**
 * ToggleItem Component.
 * @module ToggleItem
 * @TODO Move Color Palette to Intents, Accessibility
 *
 * @param {Object} props React props
 * @param {String} props.id Button Tag Label
 * @param {String} props.value Button Default Label
 * @param {Boolean} props.isSelected Button 'Setted' Label
 * @param {Function} props.onChange Buttons Active Status 'onChange' function
 * @param {String} props.label Buttons Active Status 'onChange' function
 * @param {String} props.tagLabel Buttons Active Status 'onChange' function
 * @returns {React.ReactElement} ToggleItem Component
 * @public
 */

function ToggleItem({
  id,
  name = 'segment',
  _name,
  value,
  isSelected,
  onChange,
  label = 'Label',
  tagLabel
}) {
  if (!onChange) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Switch, {
    id: id,
    onChange: onChange,
    value: value,
    type: "radio",
    checked: isSelected,
    name: name
  }), /*#__PURE__*/_react.default.createElement(Label, (0, _extends2.default)({
    htmlFor: id
  }, _patternLibraryUtils.tracking.create(_name, true, false)), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph"
  }, label), tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    "data-cy": "tag-label",
    text: tagLabel,
    size: "sm"
  })));
}
var _default = exports.default = ToggleItem;
ToggleItem.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  _name: _propTypes.default.string,
  value: _propTypes.default.string,
  isSelected: _propTypes.default.bool,
  label: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  onChange: _propTypes.default.func
};